import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface INavigateActionProps {
  button: {
    text: string;
    onClick?: () => void;
  };
  title: string;
  className?: string;
}

const NavigateAction = ({
  button: { text, onClick },
  title,
  className,
}: INavigateActionProps) => {
  return (
    <div
      className={twMerge(
        [
          "tw-flex tw-justify-between tw-space-x-5 tw-p-4 tw-items-center tw-rounded tw-bg-gray",
          "xl:tw-px-6 xl:tw-py-2",
        ],
        className,
      )}
    >
      <Text className="tw-text-wrap tw-break-words tw-font-bold">{title}</Text>

      {text && onClick && (
        <Button variant="text" onClick={onClick} className="tw-text-right">
          {text}
        </Button>
      )}
    </div>
  );
};

export default NavigateAction;
